import React from 'react';

import { ADMIN_DOCUMENTS } from '@ApplicationWide/permissions/constants';
import { ADMIN } from '@ApplicationWide/routes/route-groups';
import { FileIcon } from '@Generic/icons';

const ManageDocumentsPage = React.lazy(() => import('../../../pages/Admin/ManageDocuments/ManageDocumentsPage'));

export default {
  label: 'navigation.admin.documents.title',
  group: ADMIN,
  to: '/administration/documents',
  route: '/administration/documents',
  component: ManageDocumentsPage,
  icon: <FileIcon />,
  requiredRoles: ['admin', 'super_admin'],
  adminVisibilityPermission: ADMIN_DOCUMENTS,
  area: ADMIN_DOCUMENTS,
  hasNavBar: true,
};
